export default __webpack_public_path__ + "static/media/Pizza.624861fd.jpg";